export enum EarlyPaymentDiscountCustomMentionType {
  Custom = 'custom',
  Default = 'default',
}
